import { mapMutations } from 'vuex';
//import _ from 'lodash';
import $ from 'jquery';

import { AddToFavoriteListMixin } from '@/mixins/Bookmark/AddToFavoriteList';

export default {
  name: 'VideoItem',

  mixins: [AddToFavoriteListMixin],

  props: {
    p_video: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    ...mapMutations('Mixins/Bookmark', {
      mm_SET_SELECTED_BULLET_ID: 'SET_SELECTED_BULLET_ID',
    }),

    selectBulletAndOpenPlayer(bulletId) {
      this.mm_SET_SELECTED_BULLET_ID(bulletId);
      this.$emit('open-player');
    },

    removeFromFavoriteList(video, $event) {
      $($event.target).tooltip('hide');
      this.addToFavoriteList({
        ...video,
        toCollect: false,
      });
      this.setIsDeletedInFavoriteList(video);
    },
  },

  mounted() {
    $(this.$refs.videoItem).tooltip();
  },
};
